module.exports = __webpack_public_path__ + "img/fluent_person-12-regular.069fefe4.svg";